import { jsPDF } from "jspdf";
import 'jspdf-autotable'
function convert(alimentos) {

    var doc = new jsPDF();
    var col = ["Nutriente", "Quantidade"];
    var col1 = ["Details", "Values"];
   
    var rows1 = [];

    /* The following array of object as response from the API req  */


    alimentos.forEach(element => {
        var rows = [];
        Object.keys(element.nutrientes).forEach(elAl => {
            var temp = [elAl, element.nutrientes[elAl]];
            rows.push(temp);
        })
        doc.autoTable(col, rows, ({
            startY: 10,
        }))
        doc.text(0, data.cursor.y + 2, element.name)
        

        
        var temp1 = [element.id, element.name];
        
        rows1.push(temp1);

    });

    

    doc.autoTable(col1, rows1, {
        startY: 60
    });
    doc.output('dataurlnewwindow');
}
export const tabelaResumida = (alimentos) => {
    // Default export is a4 paper, portrait, using millimeters for units
    convert(alimentos)
}